<template>
  <div>
    <!-- Sidebar Navigation -->
    <nav
      class="fixed top-0 left-0 h-full w-64 bg-white shadow-xl z-40 transition-transform duration-300 ease-in-out"
      :class="isMobileMenuOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'"
    >
      <div class="p-6 border-b border-gray-100">
        <h1 class="text-2xl font-bold bg-gradient-to-r from-red-600 to-red-500 bg-clip-text text-transparent">
          CashRequest
        </h1>
      </div>

      <div class="flex flex-col h-full">
        <ul class="space-y-1 p-4 flex-grow">
          <li>
            <router-link
              to="/dashboard"
              class="nav-link group"
              @click="closeMobileMenu"
            >
              <div class="nav-icon bg-blue-100 text-blue-600 group-hover:bg-blue-200">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6-8h6"/>
                </svg>
              </div>
              <span class="font-medium">Dashboard</span>
            </router-link>
          </li>

          <li v-if="user.role !== 'admin'">
            <router-link
              to="/history"
              class="nav-link group"
              @click="closeMobileMenu"
            >
              <div class="nav-icon bg-purple-100 text-purple-600 group-hover:bg-purple-200">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
                </svg>
              </div>
              <span class="font-medium">Request History</span>
            </router-link>
          </li>

          <li v-if="user.role !== 'employee'">
            <router-link
              v-if="user.role !== 'admin'"
              to="/approvals"
              class="nav-link group"
              @click="closeMobileMenu"
            >
              <div class="nav-icon bg-green-100 text-green-600 group-hover:bg-green-200">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                </svg>
              </div>
              <span class="font-medium">Pending Approvals</span>
              <span v-if="pendingApprovalsCount > 0"
                    class="ml-auto bg-red-500 text-white text-xs px-2 py-1 rounded-full">
                {{ pendingApprovalsCount }}
              </span>
            </router-link>
          </li>

          <li v-if="user.role !== 'employee'">
            <router-link
              v-if="user.role !== 'admin'"
              to="/my-approvals"
              class="nav-link group"
              @click="closeMobileMenu"
            >
              <div class="nav-icon bg-teal-100 text-teal-600 group-hover:bg-teal-200">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"/>
                </svg>
              </div>
              <span class="font-medium">My Approvals</span>
            </router-link>
          </li>

          <li v-if="user.role !== 'admin'">
            <button
              @click="handleNewRequest"
              class="nav-link group w-full text-left"
            >
              <div class="nav-icon bg-emerald-100 text-emerald-600 group-hover:bg-emerald-200">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
                </svg>
              </div>
              <span class="font-medium">New Request</span>
            </button>
          </li>

          <li v-if="user.role === 'admin'">
            <router-link
              to="/admin"
              class="nav-link group"
              @click="closeMobileMenu"
            >
              <div class="nav-icon bg-orange-100 text-orange-600 group-hover:bg-orange-200">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"/>
                </svg>
              </div>
              <span class="font-medium">Admin Panel</span>
            </router-link>
          </li>

          <li v-if="user.role === 'finance' || user.role === 'ceo' || user.role === 'managing_director' || user.role === 'admin'">
            <router-link
              to="/stats"
              class="nav-link group"
              @click="closeMobileMenu"
            >
              <div class="nav-icon bg-indigo-100 text-indigo-600 group-hover:bg-indigo-200">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"/>
                </svg>
              </div>
              <span class="font-medium">Statistics</span>
            </router-link>
            <router-link
              to="/settlement"
              class="nav-link group"
              @click="closeMobileMenu"
            >
              <div class="nav-icon bg-indigo-100 text-indigo-600 group-hover:bg-indigo-200">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"/>
                </svg>
              </div>
              <span class="font-medium">Settlements</span>
            </router-link>
            <router-link
              to="/reports"
              class="nav-link group"
              @click="closeMobileMenu"
            >
              <div class="nav-icon bg-indigo-100 text-indigo-600 group-hover:bg-indigo-200">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"/>
                </svg>
              </div>
              <span class="font-medium">Reports</span>
            </router-link>
          </li>
          <li class="border-t border-gray-100">
            <div>
              <button
                @click="logout"
                class="flex items-center w-full p-3 rounded-xl text-gray-700 hover:text-red-600 hover:bg-red-50 transition-all duration-200 group"
              >
                <div class="w-8 h-8 rounded-lg bg-red-100 text-red-600 group-hover:bg-red-200 flex items-center justify-center mr-3 transition-colors duration-200">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"/>
                  </svg>
                </div>
                <span class="font-medium">Logout</span>
              </button>
            </div>
          </li>
        </ul>
      </div>
    </nav>

    <!-- Mobile Menu Button -->
    <button
      @click="isMobileMenuOpen = !isMobileMenuOpen"
      class="lg:hidden fixed top-4 left-4 z-50 p-2 bg-white rounded-lg shadow-lg"
    >
      <svg class="w-6 h-6 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path v-if="!isMobileMenuOpen" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"/>
        <path v-else stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
      </svg>
    </button>

    <!-- Mobile Menu Overlay -->
    <div
      v-if="isMobileMenuOpen"
      @click="closeMobileMenu"
      class="lg:hidden fixed inset-0 bg-black bg-opacity-50 z-30"
    ></div>
  </div>
</template>

<script>
export default {
  name: 'Sidebar',
  props: {
    pendingApprovalsCount: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      user: JSON.parse(localStorage.getItem('user') || '{}'),
      isMobileMenuOpen: false
    };
  },
  methods: {
    closeMobileMenu() {
      this.isMobileMenuOpen = false;
    },
    handleNewRequest() {
      this.closeMobileMenu();
      this.$emit('open-create-modal');
    },
    logout() {
      this.$emit('logout');
    }
  }
};
</script>

<style scoped>
.nav-link {
  @apply flex items-center p-3 rounded-xl text-gray-700 hover:text-gray-900 hover:bg-gray-50 transition-all duration-200 font-medium;
}

.nav-icon {
  @apply w-8 h-8 rounded-lg flex items-center justify-center mr-3 transition-colors duration-200;
}

/* Custom scrollbar for sidebar */
nav::-webkit-scrollbar {
  width: 4px;
}

nav::-webkit-scrollbar-track {
  background: transparent;
}

nav::-webkit-scrollbar-thumb {
  background: #e5e7eb;
  border-radius: 2px;
}

nav::-webkit-scrollbar-thumb:hover {
  background: #d1d5db;
}
</style>
